import axios from "axios";

let apiUrl;

const apiUrls = {
  production: "https://mern-sales-funnel-template.onrender.com", 
  development: "https://mern-sales-funnel-template.onrender.com",
};

if (window.location.hostname === "localhost") {
  apiUrl = apiUrls.development;
} else {
  apiUrl = apiUrls.production;
}

const api = axios.create({
  baseURL: apiUrl,
});

export default api;